import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css';
import Layout from './layout/';
import { formatUrl, formatImage } from '@ifeng-fe/public_method';

/* eslint-disable */
const handleNewsStream = (data, len = 8, w = 750, h = 376) => {
    let result = [];

    try {
        result = data.slice(0, len).map(item => {
            const __imageArr = item.thumbnails ? item.thumbnails.image : [];
            const __imageItem = __imageArr[0] ? __imageArr[0] : [];

            const __image = __imageItem.url ? formatImage(__imageItem.url, w, h) : '';

            let __serial = '';

            if (item.title2) {
                const matchResult = item.title2.match(/第(\d*)期/);

                if (matchResult !== null) {
                    __serial = matchResult[1];
                }
            }

            let __title = item.title || '';

            if (item.title.indexOf('地球青年 | ') > -1) {
                __title = item.title.split('地球青年 | ')[1];
            } else if (item.title.indexOf('期：') > -1) {
                __title = item.title.split('期：')[1];
            }

            return {
                id: item.id,
                serial: __serial,
                thumbnail: __image,
                title: __title,
                summary: item.summary,
                url: formatUrl(item.url),

                commentUrl: item.commentUrl,
                skey: item.skey,
                author: item.author,
                source: item.source,
                newsTime: item.newsTime,
            };
        });

        return result;
    } catch (error) {
        console.error(error);
        
        return result;
    }
};

allData.newsstream = handleNewsStream(allData.newsstream);
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
